function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M441.962,284.364l-59.389-59.383c-15.984-15.985-35.396-23.982-58.238-23.982c-23.223,0-43.013,8.375-59.385,25.125 l-25.125-25.125c16.751-16.368,25.125-36.256,25.125-59.671c0-22.841-7.898-42.157-23.698-57.958l-58.815-59.097 c-15.798-16.178-35.212-24.27-58.242-24.27c-22.841,0-42.16,7.902-57.958,23.7L24.267,65.386C8.088,81.188,0,100.504,0,123.343 c0,22.841,7.996,42.258,23.982,58.245l59.385,59.383c15.99,15.988,35.404,23.982,58.245,23.982 c23.219,0,43.015-8.374,59.383-25.126l25.125,25.126c-16.75,16.371-25.125,36.258-25.125,59.672 c0,22.843,7.898,42.154,23.697,57.958l58.82,59.094c15.801,16.177,35.208,24.27,58.238,24.27c22.844,0,42.154-7.897,57.958-23.698 l41.973-41.682c16.177-15.804,24.271-35.118,24.271-57.958C465.947,319.771,457.953,300.359,441.962,284.364z M200.999,162.178 c-0.571-0.571-2.334-2.378-5.28-5.424c-2.948-3.046-4.995-5.092-6.136-6.14c-1.143-1.047-2.952-2.474-5.426-4.286 c-2.478-1.809-4.902-3.044-7.28-3.711c-2.38-0.666-4.998-0.998-7.854-0.998c-7.611,0-14.084,2.666-19.414,7.993 c-5.33,5.327-7.992,11.799-7.992,19.414c0,2.853,0.332,5.471,0.998,7.851c0.666,2.382,1.903,4.808,3.711,7.281 c1.809,2.474,3.237,4.283,4.283,5.426c1.044,1.141,3.09,3.188,6.136,6.139c3.046,2.95,4.853,4.709,5.424,5.281 c-5.711,5.898-12.563,8.848-20.555,8.848c-7.804,0-14.277-2.568-19.414-7.705L62.81,142.761c-5.327-5.33-7.992-11.802-7.992-19.417 c0-7.421,2.662-13.796,7.992-19.126l41.971-41.687c5.523-5.14,11.991-7.705,19.417-7.705c7.611,0,14.083,2.663,19.414,7.993 l58.813,59.097c5.33,5.33,7.992,11.801,7.992,19.414C210.418,149.321,207.278,156.27,200.999,162.178z M403.147,361.732 l-41.973,41.686c-5.332,4.945-11.8,7.423-19.418,7.423c-7.809,0-14.27-2.566-19.41-7.707l-58.813-59.101 c-5.331-5.332-7.99-11.8-7.99-19.41c0-7.994,3.138-14.941,9.421-20.841c0.575,0.567,2.334,2.381,5.284,5.42 c2.95,3.046,4.996,5.093,6.14,6.14c1.143,1.051,2.949,2.478,5.42,4.288c2.478,1.811,4.9,3.049,7.282,3.713 c2.382,0.667,4.997,0.999,7.851,0.999c7.618,0,14.086-2.665,19.418-7.994c5.324-5.328,7.994-11.8,7.994-19.41 c0-2.854-0.339-5.472-1-7.851c-0.67-2.382-1.902-4.809-3.72-7.282c-1.811-2.471-3.23-4.284-4.281-5.428 c-1.047-1.136-3.094-3.183-6.139-6.14c-3.046-2.949-4.853-4.709-5.428-5.276c5.715-6.092,12.566-9.138,20.554-9.138 c7.617,0,14.085,2.663,19.41,7.994l59.388,59.382c5.332,5.332,7.995,11.807,7.995,19.417 C411.132,350.032,408.469,356.415,403.147,361.732z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 465.951 465.951",
    style: {
      enableBackground: "new 0 0 465.951 465.951",
      fill: "#ccc"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.e639d3ce.svg";
export { ForwardRef as ReactComponent };